import * as React from "react";
import { cx } from "../utils/cx";
export function SkeletonCellContent({ compact }) {
    return React.createElement("div", { className: cx(compact ? "h-4" : "h-6", "bg-active-neutral-secondary rounded-md animate-pulse") });
}
const DEFAULT_LOADING_ROWS = 3;
export const defaultRenderLoadingTableBody = ({ rowCount, cellCount, compact }) => {
    return (React.createElement("tbody", null, [...Array(rowCount || DEFAULT_LOADING_ROWS)].map((_rowVal, rowIndex) => (
    // eslint-disable-next-line react/no-array-index-key -- there is nothing else to use
    React.createElement("tr", { className: cx("border-b border-separator"), key: `loaderRow-${rowIndex}` }, [...Array(cellCount)].map((_cellVal, cellIndex) => (
    // eslint-disable-next-line react/no-array-index-key,jsx-a11y/control-has-associated-label -- there is nothing else to use -- this is a skeleton loader
    React.createElement("td", { className: cx(compact ? "p-1" : "p-3"), key: `loaderCell-${rowIndex}-${cellIndex}` },
        React.createElement(SkeletonCellContent, null)))))))));
};
export function LoadingTableBody(props) {
    return defaultRenderLoadingTableBody(props);
}
